// extracted by mini-css-extract-plugin
module.exports = {"m-1600":"download_m-1600___yNFl","container":"download_container__u5fD5","list":"download_list__JUNMC","item":"download_item__MFal4"};